$(document).ready(function() {
    var LookupTable = {
        initData: function() {
            this.sizeData = window.condom_sizes;
        },
        //getSizeCode: function(selectedCircumference, selectedLength, extraLength, tighterOrLooser) {
      	getSizeCode: function(selectedCircumference, selectedLength) {
            // Filter circumference data (x axis)
            var matchedCircumferences = _.filter(this.sizeData.data, function(row) {
                return (selectedCircumference >= row.circ.min && selectedCircumference <= row.circ.max)
            });

            // Filter length data (y axis)
            var matchedLengths = _.filter(matchedCircumferences, function(row) {
                return (selectedLength >= row.len.min && selectedLength <= row.len.max)
            });
            var result = {
                msgId : 0,
                code : 'Unknown'
            }
            if(matchedLengths.length > 0) {
                /*result
                    = this.checkPreferences(
                        matchedLengths[0].code,
                        extraLength,
                        tighterOrLooser
                    );*/
              	result = this.checkPreferences(matchedLengths[0].code);
            }
            return result;
        },
        //checkPreferences: function(code, extraLength, tighterOrLooser) {
      	checkPreferences: function(code) {
            // Find the X and Y co-ords in the lookup table of selected size code
            var matchedCoords = _.filter(this.sizeData.data, function(data) {
                return (data.code == code)
            });
            var row = matchedCoords[0].row;
            var col = matchedCoords[0].col;
            // Lookup the row beneath selected size code if extra length selected
            /*if(extraLength) {
                row += 1;
            }
            // Lookup the col to the right if looser fit selected
            if(tighterOrLooser == 1) {
                col += 1;
            }
            // Lookup the col to the left if tighter fit selected
            if(tighterOrLooser == 2) {
                col -= 1;
            }
            */
            var newSizeCode = _.filter(this.sizeData.data, function(data) {
                return (data.row == row && data.col == col);
            });
            if(newSizeCode.length > 0) {
                return newSizeCode[0];
            } else {
               return {msgId : 0, code : 'Unknown'}
            }
        }
    };
    var MeasurerView = Backbone.View.extend({
        el : $('#measurer'),
        lookupTable : LookupTable,
        initialize: function() {
            this.lookupTable.initData();
            this.render();
            this.initSliders();
            this.initInputFields();
        },
        adjustLengthSlider: function(value) {
            if(value >= this.lookupTable.sizeData.minLength && value <= this.lookupTable.sizeData.maxLength)
            {
                $( "#slider-length" ).slider( "value", value );
                $( "#selected-length-error" ).text('');
            }
            else
            {
                $( "#selected-length-error" ).text("Please enter a value between "+this.lookupTable.sizeData.minLength+"mm and "+this.lookupTable.sizeData.maxLength+"mm");
            }
        },
        adjustGirthSlider: function(value) {
            if(value >= this.lookupTable.sizeData.minWidth && value <= this.lookupTable.sizeData.maxWidth)
            {
                $( "#slider-girth" ).slider( "value", value );
                $( "#selected-girth-error" ).text('');
            }
            else
            {
                $( "#selected-girth-error" ).text("Please enter a value between "+this.lookupTable.sizeData.minWidth+"mm and "+this.lookupTable.sizeData.maxWidth+"mm");
            }
        },
        initInputFields : function() {
            var self = this;
            var selectedLengthField = $( "#selected-length");
            var selectedGirthField = $( "#selected-girth");
            selectedLengthField.keydown(function (e) {
                if(e.keyCode == 13 || e.keyCode == 9)
                {
                    self.adjustLengthSlider($(this).val());
                }
            });
            selectedGirthField.keydown(function (e) {
                if(e.keyCode == 13 || e.keyCode == 9)
                {
                    self.adjustGirthSlider($(this).val());
                }
            });
            selectedLengthField.blur(function() {
                self.adjustLengthSlider($(this).val());
            });
            selectedGirthField.blur(function() {
                self.adjustGirthSlider($(this).val());
            });
        },
        initSliders : function () {
            var self = this;
            $( "#slider-length" ).slider({
                min: this.lookupTable.sizeData.minLength,
                max: this.lookupTable.sizeData.maxLength,
                value: 100,
                slide: function( event, ui ) {
                    self.displayLength(ui.value)
                },
                change: function(event, ui) {
                    self.initSubmit();
                }
            });
            $( "#slider-girth" ).slider({
                min: this.lookupTable.sizeData.minWidth,
                max: this.lookupTable.sizeData.maxWidth,
                value: 100,
                slide: function( event, ui ) {
                    self.displayGirth(ui.value)
                },
                change: function(event, ui) {
                    self.initSubmit();
                }
            });
            this.displayLength($("#slider-length").slider('value'));
            this.displayGirth($("#slider-girth").slider('value'));
        },
        initSubmit: function() {
            var self = this;
            var data = self.calculateSize();
            //var templateMessage = _.template($("#message_template_" + data.msgId).html(), {code : data.code});
            var templateContents = $("#message_template_" + data.msgId).html();
            var sizeTemplate = _.template(templateContents);
            var rendered = sizeTemplate({code : data.code.toLowerCase()});

            //$('#size-code').html(rendered);
            if(data.msgId > 0) {
                //var templateClickToBuy = _.template($("#click_to_buy_template").html(), {code : data.code});
                var templateClickToBuy = $("#click_to_buy_template").html();
                var buyTemplate = _.template(templateClickToBuy);
                var buyRendered = buyTemplate({code : data.oldCode.toLowerCase()});
                $('#size-code').html(rendered).append(buyRendered);
            } else {
                $('#size-code').html(rendered);
            }
        },
        calculateSize: function() {
            var length = $( "#selected-length" ).val();
            var girth = $( "#selected-girth" ).val();
          	// removed by request
            //var extraLengthRequired = $('input:checkbox[id=extra-length]:checked').val();
            //var tighterOrLooser = $('#prefs :selected').val();
            length = parseInt(length);
            girth = parseInt(girth);
            //return this.lookupTable.getSizeCode(girth, length, extraLengthRequired, tighterOrLooser);
          	return this.lookupTable.getSizeCode(girth, length);
        },
        displayLength: function(value) {
            $( "#selected-length" ).val( value );
        },
        displayGirth: function(value) {
            $( "#selected-girth" ).val( value );
        },
        render : function() {
            var template = _.template($("#measurer_template").html());
            //var template = _.template(templateHTML);
            //$('.myElement').html(template( {'helloVar': 1234} ));
            $(this.el).html(template);
        }
    });
    return new MeasurerView();
});